import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokalyancab() {



  const cardData = {


  keyword: "Pune to Kalyan Cab",

  headingDescription: "Trustline Cab offers dependable Pune to Kalyan cab services with safe, comfortable, and affordable transportation for corporate travel, business meetings, family visits, railway station transfers, airport connectivity, medical appointments, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups and a smooth, hassle-free ride. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Kalyan taxi services.",

  topPlaces: [
    {
      title: "Kalyan West",
      description: "Kalyan West is a well-established commercial and residential locality featuring shopping centers, corporate offices, educational institutions, healthcare facilities, and excellent railway connectivity. It serves as a major destination for business travelers, professionals, and families visiting the Mumbai Metropolitan Region."
    },
    {
      title: "Kalyan East",
      description: "Kalyan East is a rapidly developing suburb known for modern residential projects, commercial establishments, schools, hospitals, and expanding infrastructure. Its strategic location offers convenient access to Thane, Navi Mumbai, and major industrial corridors across the region."
    },
    {
      title: "Dombivli",
      description: "Dombivli is one of the fastest-growing cities near Kalyan, offering thriving business districts, manufacturing units, educational institutions, retail markets, and excellent transport connectivity. It is a preferred destination for professionals, entrepreneurs, and corporate visitors."
    },
    {
      title: "Bhiwandi",
      description: "Bhiwandi is India's leading warehousing and logistics hub, home to large distribution centers, industrial parks, textile businesses, and e-commerce fulfillment facilities. It attracts business travelers, logistics professionals, and industrial visitors throughout the year."
    },
    {
      title: "Murbad MIDC",
      description: "Murbad MIDC is an emerging industrial zone with engineering companies, manufacturing plants, warehouses, and commercial establishments. It plays an important role in supporting industrial growth and business activities in the Kalyan region."
    },
    {
      title: "Kalyan Railway Junction",
      description: "Kalyan Junction is one of Central Railway's busiest railway stations, connecting Mumbai with Pune, Nashik, Nagpur, and several major cities across India. It is an important transportation hub for business and leisure travelers."
    },
    {
      title: "Kala Talao Lake",
      description: "Kala Talao Lake is a peaceful recreational destination in Kalyan, featuring landscaped gardens, walking paths, boating facilities, and relaxing surroundings. It is a popular attraction for families, morning walkers, and visitors seeking a calm outdoor experience."
    },
    {
      title: "Durgadi Fort",
      description: "Durgadi Fort is a historic landmark overlooking Kalyan Creek, known for its ancient architecture, temple, and panoramic views. It attracts history enthusiasts, photographers, and tourists interested in Maharashtra's rich cultural heritage."
    },
    {
      title: "Metro Junction Mall",
      description: "Metro Junction Mall is one of Kalyan's premier shopping and entertainment destinations, offering branded retail stores, restaurants, multiplex cinemas, gaming zones, and family-friendly attractions under one roof."
    },
    {
      title: "Malanggad Fort",
      description: "Malanggad Fort is a popular trekking and pilgrimage destination near Kalyan, admired for its scenic hilltop views, historical significance, and the famous Haji Malang Dargah, attracting visitors throughout the year."
    }
  ],






"services": [
  {
    "name": "Pune to Kalyan Cab Booking",
    "description": "Book Pune to Kalyan Cab Booking with instant confirmation, clean AC cars, experienced drivers, and affordable fares."
  },
  {
    "name": "Pune to Kalyan Cab Fare",
    "description": "Check Pune to Kalyan Cab Fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV."
  },
  {
    "name": "Pune to Kalyan Taxi",
    "description": "Choose Pune to Kalyan Taxi for safe, comfortable, and reliable intercity travel with professional chauffeurs."
  },
  {
    "name": "Pune to Kalyan Taxi Fare",
    "description": "View Pune to Kalyan Taxi Fare with fixed rates, affordable pricing, and multiple vehicle options."
  },
  {
    "name": "Kalyan to Pune Cab",
    "description": "Book Kalyan to Pune Cab with doorstep pickup, clean vehicles, and experienced drivers."
  },
  {
    "name": "Kalyan to Pune Cab Charges",
    "description": "Check Kalyan to Pune Cab Charges with transparent fares and no hidden costs."
  },
  {
    "name": "Kalyan to Pune Cab Fare",
    "description": "Compare Kalyan to Pune Cab Fare for Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Kalyan to Pune Car Rental",
    "description": "Choose Kalyan to Pune Car Rental with chauffeur-driven AC vehicles for comfortable travel."
  },
  {
    "name": "Kalyan to Pune Taxi",
    "description": "Hire Kalyan to Pune Taxi for business, family, and airport travel with reliable service."
  },
  {
    "name": "Kalyan to Pune Taxi Fare",
    "description": "Check Kalyan to Pune Taxi Fare with affordable pricing and professional drivers."
  },
  {
    "name": "Kalyan to Pune Taxi Service",
    "description": "Book Kalyan to Pune Taxi Service with clean cars, timely pickup, and comfortable travel."
  },
  {
    "name": "Pune to Kalyan Cab",
    "description": "Book Pune to Kalyan Cab with AC vehicles, experienced chauffeurs, and affordable fares."
  },
  {
    "name": "Pune to Kalyan Cab Service",
    "description": "Choose Pune to Kalyan Cab Service for one-way and round-trip intercity travel."
  },
  {
    "name": "Pune to Kalyan Taxi",
    "description": "Travel with Pune to Kalyan Taxi offering safe rides, fixed pricing, and clean vehicles."
  },
  {
    "name": "Pune to Kalyan Taxi Service",
    "description": "Reserve Pune to Kalyan Taxi Service with reliable drivers and comfortable AC cars."
  },
  {
    "name": "Pune to Kalyan Cab Booking",
    "description": "Complete Pune to Kalyan Cab Booking online with instant confirmation and fixed fares."
  },
  {
    "name": "Online Pune to Kalyan Cab Booking",
    "description": "Use Online Pune to Kalyan Cab Booking for quick reservations and secure booking."
  },
  {
    "name": "Book Pune to Kalyan Cab",
    "description": "Book Pune to Kalyan Cab anytime with affordable pricing and professional chauffeurs."
  },
  {
    "name": "Pune to Kalyan One Way Cab",
    "description": "Choose Pune to Kalyan One Way Cab and pay only for your one-side journey."
  },
  {
    "name": "Pune to Kalyan Round Trip Cab",
    "description": "Book Pune to Kalyan Round Trip Cab with flexible return timing and premium vehicles."
  },
  {
    "name": "Pune to Kalyan Outstation Cab",
    "description": "Travel comfortably with Pune to Kalyan Outstation Cab and experienced drivers."
  },
  {
    "name": "Pune to Kalyan Car Rental",
    "description": "Choose Pune to Kalyan Car Rental with Sedan, Ertiga, Innova Crysta, and SUV."
  },
  {
    "name": "Pune to Kalyan Private Cab",
    "description": "Hire Pune to Kalyan Private Cab for exclusive and comfortable intercity travel."
  },
  {
    "name": "Pune to Kalyan AC Cab",
    "description": "Book Pune to Kalyan AC Cab with clean air-conditioned vehicles and professional drivers."
  },
  {
    "name": "Pune to Kalyan Intercity Cab",
    "description": "Choose Pune to Kalyan Intercity Cab for reliable, safe, and affordable travel."
  },
  {
    "name": "Pune to Kalyan Drop Taxi",
    "description": "Book Pune to Kalyan Drop Taxi with direct destination drop and transparent pricing."
  },
  {
    "name": "Pune to Kalyan Travel Cab",
    "description": "Reserve Pune to Kalyan Travel Cab for family trips, business travel, and weekend journeys."
  }
],

"tableData": [
  ["Pune to Kalyan Cab Booking", "Pune to Kalyan Cab Fare"],
  ["Pune to Kalyan Taxi", "Pune to Kalyan Taxi Fare"],
  ["Kalyan to Pune Cab", "Kalyan to Pune Cab Charges"],
  ["Kalyan to Pune Cab Fare", "Kalyan to Pune Car Rental"],
  ["Kalyan to Pune Taxi", "Kalyan to Pune Taxi Fare"],
  ["Kalyan to Pune Taxi Service", "Pune to Kalyan Cab"],
  ["Pune to Kalyan Cab Service", "Pune to Kalyan Taxi"],
  ["Pune to Kalyan Taxi Service", "Pune to Kalyan Cab Booking"],
  ["Online Pune to Kalyan Cab Booking", "Book Pune to Kalyan Cab"],
  ["Pune to Kalyan One Way Cab", "Pune to Kalyan Round Trip Cab"],
  ["Pune to Kalyan Outstation Cab", "Pune to Kalyan Car Rental"],
  ["Pune to Kalyan Private Cab", "Pune to Kalyan AC Cab"],
  ["Pune to Kalyan Intercity Cab", "Pune to Kalyan Drop Taxi"],
  ["Pune to Kalyan Travel Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Trusted Pune to Kalyan Cab Service",
    WhyChoosedescription: "Trustline Cab provides reliable Pune to Kalyan cab services with comfortable vehicles for business travel, family visits, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Convenient Pickup from Every Corner of Pune",
    WhyChoosedescription: "Enjoy doorstep pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Smooth Highway Travel Experience",
    WhyChoosedescription: "Our trained chauffeurs ensure a safe and comfortable journey via the Mumbai-Pune Expressway with timely arrivals."
  },
  {
    WhyChooseheading: "Competitive Cab Fare",
    WhyChoosedescription: "Benefit from affordable pricing, transparent quotations, and zero hidden charges for your Pune to Kalyan cab booking."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Traveler",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit solo travelers, families, and larger groups."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Flexibility",
    WhyChoosedescription: "Book a one-way ride, return journey, or personalized travel package according to your travel plans."
  },
  {
    WhyChooseheading: "Suitable for Personal & Corporate Travel",
    WhyChoosedescription: "Whether you're traveling for office work, family functions, hospital visits, or leisure, our Pune to Kalyan cab service offers a dependable travel solution."
  },
  {
    WhyChooseheading: "Instant Booking with Dedicated Support",
    WhyChoosedescription: "Get immediate fare estimates, quick booking confirmation, and responsive customer assistance 24/7."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Kalyan cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Kalyan cab services for one-way travel, round trips, corporate travel, airport transfers, and family journeys."
  },
  {
    question: "Can I book a one-way cab from Pune to Kalyan?",
    answer: "Yes, affordable one-way cab services are available with doorstep pickup from any location in Pune."
  },
  {
    question: "Which vehicles are available for Pune to Kalyan travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Do you offer pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we provide pickup services from Pune Airport, Pune Railway Station, hotels, offices, and residential locations throughout Pune."
  },
  {
    question: "Can I reserve a round-trip cab to Kalyan?",
    answer: "Yes, Trustline Travels offers flexible round-trip packages for business visits, family travel, and personal requirements."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in your booking quotation."
  },
  {
    question: "Is Pune to Kalyan cab service available 24/7?",
    answer: "Yes, our cab services are available throughout the day and night to match your preferred travel schedule."
  },
  {
    question: "Can I schedule my cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup timing."
  },
  {
    question: "Is this service suitable for corporate and family travel?",
    answer: "Yes, our Pune to Kalyan cab service is ideal for business professionals, families, tourists, students, and individual travelers."
  },
  {
    question: "How can I book a Pune to Kalyan cab with Trustline Travels?",
    answer: "Simply provide your pickup address, destination, travel date, passenger details, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Abhishek Gokhale",
    feedback: "Everything from the booking process to the final drop in Kalyan was handled efficiently. The vehicle was clean, the driver maintained excellent professionalism, and the journey remained comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nandita Verma",
    feedback: "Trustline Travels impressed us with punctual service, courteous staff, and a well-maintained cab. The smooth travel experience and transparent pricing made this an excellent choice for our Pune to Kalyan journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kalyan Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-kalyan-cab.webp",
  "description": "Book Pune to Kalyan cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6297"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-kalyan-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Kalyan Cab | One Way & Round Trip Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Kalyan cab service with Trustline Travels for reliable and affordable intercity travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to kalyan cab booking, Pune to kalyan cab fare, Pune to kalyan taxi, Pune to kalyan taxi fare, kalyan to pune cab, Kalyan to pune cab charges, Kalyan to pune cab fare, Kalyan to pune car rental, Kalyan to pune taxi, Kalyan to pune taxi fare, Kalyan to pune taxi service, Pune to Kalyan Cab, Pune Kalyan one way cab, Pune Kalyan round trip taxi, Pune Kalyan outstation cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/82.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokalyancab;